import React from 'react'
import moment from 'moment'

interface VerticalDateTimeProps {
  datetime: string
  className?: string
}

// Parse incoming time string in 'hh:mm A' format to 24-hour
const formattedTime = (datetime: string) => {
  return datetime ? moment(datetime).format('HH:mm') : ''
}

const formattedDate = (datetime: string) => {
  return datetime ? moment(datetime).format('MMM D') : ''
}

const VerticalDateTime: React.FC<VerticalDateTimeProps> = ({
  datetime,
  className = '',
}) => {
  return (
    <div className={`d-flex flex-column align-items-center gap-2 ${className}`}>
      <div className='d-flex flex-column align-items-start gap-1' style={{ lineHeight: 1 }}>
        <label className='m-0 text-dark fs-5'>
          {formattedTime(datetime)}
        </label>
        <label className='m-0 text-gray-600 fs-6 text-center'>
          {formattedDate(datetime)}
        </label>
      </div>
    </div>
  )
}

export default VerticalDateTime 